export default "__VITE_ASSET__BPSZI3k$__"